export const emailRegex = /^[\w-'.]+([+]?)+([\w-'.]?)+@([\w-]+\.)+[\w-]*$/;
